import { render, staticRenderFns } from "./CreateAdministrator.vue?vue&type=template&id=93aea566"
import script from "./CreateAdministrator.vue?vue&type=script&lang=js"
export * from "./CreateAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports